const UserData = () => {
   return [
      {
         employeeCode: 1,
         firstName: 'Hong',
         lastName: 'Ly',
         phone: '0938887761',
         designation: '+07:00',
         email: 'hong@gmail.com',
         address: '19 Dang Tien Dong',
         status: 'Enabled',
         image: '',
         biometric: {
            face: 1,
            finger: 0,
            iris: 0,
         },
         userGroup: [
            { groupName: 'IT', groupDescription: 'IT Group' },
            { groupName: 'Design', groupDescription: 'Design Group' },
         ],
         devices: [{ description: 'MSI' }, { description: 'Xiaomi 14' }],
         admin: false,
         isManager: false,
         writePermission: 'readOnly',
      },
      {
         employeeCode: 2,
         firstName: 'Hoang',
         lastName: 'Do',
         phone: '0938887761',
         designation: '+07:00',
         email: 'hoang@gmail.com',
         address: '19 Dang Tien Dong',
         status: 'Enabled',
         image: '',
         biometric: {
            face: 1,
            finger: 0,
            iris: 0,
         },
         userGroup: [
            { groupName: 'IT', groupDescription: 'IT Group' },
            { groupName: 'Design', groupDescription: 'Design Group' },
         ],
         devices: [],
         admin: false,
         isManager: false,
         writePermission: 'readOnly',
      },
      {
         employeeCode: 3,
         firstName: 'Giang',
         lastName: 'Ngo',
         phone: '0938887761',
         designation: '+07:00',
         email: 'giang@gmail.com',
         address: '19 Dang Tien Dong',
         status: 'Disabled',
         image: '',
         biometric: {
            face: 0,
            finger: 0,
            iris: 0,
         },
         userGroup: [],
         devices: [{ description: 'MSI' }],
         admin: false,
         isManager: false,
         writePermission: 'readOnly',
      },
      {
         employeeCode: 4,
         firstName: 'Thang',
         lastName: 'Le',
         phone: '0938887761',
         designation: '+07:00',
         email: 'thang@gmail.com',
         address: '19 Dang Tien Dong',
         status: 'Enabled',
         image: '',
         biometric: {
            face: 1,
            finger: 0,
            iris: 0,
         },
         userGroup: [
            { groupName: 'IT', groupDescription: 'IT Group' },
            { groupName: 'Design', groupDescription: 'Design Group' },
         ],
         devices: [{ description: 'MSI' }],
         admin: false,
         isManager: false,
         writePermission: 'readOnly',
      },
      {
         employeeCode: 5,
         firstName: 'Thinh',
         lastName: 'Do',
         phone: '0938887761',
         designation: '+07:00',
         email: 'thinh@gmail.com',
         address: '19 Dang Tien Dong',
         status: 'Enabled',
         image: '',
         biometric: {
            face: 1,
            finger: 0,
            iris: 0,
         },
         userGroup: [
            { groupName: 'IT', groupDescription: 'IT Group' },
            { groupName: 'Design', groupDescription: 'Design Group' },
         ],
         devices: [{ description: 'MSI' }],
         admin: false,
         isManager: false,
         writePermission: 'readOnly',
      },
      {
         employeeCode: 6,
         firstName: 'Nam',
         lastName: 'Ho',
         phone: '0938887761',
         designation: '+07:00',
         email: 'nam@gmail.com',
         address: '19 Dang Tien Dong',
         status: 'Enabled',
         image: '',
         biometric: {
            face: 1,
            finger: 0,
            iris: 0,
         },
         userGroup: [{ groupName: 'IT', groupDescription: 'IT Group' }],
         devices: [{ description: 'MSI' }],
         admin: false,
         isManager: false,
         writePermission: 'readOnly',
      },
      {
         employeeCode: 7,
         firstName: 'Ngan',
         lastName: 'Nguyen',
         phone: '0938887761',
         designation: '+07:00',
         email: 'ngan@gmail.com',
         address: '19 Dang Tien Dong',
         status: 'Enabled',
         image: '',
         biometric: {
            face: 1,
            finger: 0,
            iris: 0,
         },
         userGroup: [
            { groupName: 'IT', groupDescription: 'IT Group' },
            { groupName: 'Design', groupDescription: 'Design Group' },
         ],
         devices: [{ description: 'MSI' }],
         admin: false,
         isManager: false,
         writePermission: 'readOnly',
      },
   ];
};

export default UserData;
